<mat-dialog-content class="dialog-content">

  <div class="">
    {{ 'Duplicate_sessions' | translate }}
  </div>

  <form [formGroup]="duplicationForm" class="form">
    <mat-form-field>
      <mat-select placeholder="{{ 'Select_weeks' | translate }}" formControlName="weeks" multiple>
        <mat-option *ngFor="let week of weeks" [value]="week">
          {{ "Week" | translate }} {{ week.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="f['weeks'].errors && f['weeks'].hasError('required')">{{ 'Field_required' | translate }}</mat-error>
    </mat-form-field>
    <mat-checkbox
      [checked]="isOverrideEnabled"
      (change)="onOverrideSelectionChange()">
      {{ 'Override_sessions' | translate }}
    </mat-checkbox>
  </form>

</mat-dialog-content>
<mat-dialog-actions class="dialog-actions">
  <button mat-button mat-dialog-close>{{ 'Cancel' | translate }}</button>
  <button mat-raised-button [disabled]="f['weeks'].hasError('required') || isSubmitting" (click)="onConfirmClicked()" color="accent">{{ 'Duplicate' | translate }}</button>
</mat-dialog-actions>
